import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberLaboratories } from "./routeType";

const { key, getPath } = getApi("members.laboratories.get");

type IExtractedRouteType = IMemberLaboratories["laboratorySingleRetrieve"];

export type IGetMemberLaboratory = IPickSingleQuery<IExtractedRouteType>;

const getMemberLaboratory: Fetcher<
  IGetMemberLaboratory["response"],
  IGetMemberLaboratory["variables"]
> = ({ labId, ...params }) => {
  return axiosClient.get(getPath({ labId }), { params });
};

export const useGetMemberLaboratory = createQuery({
  queryKey: [key],
  fetcher: getMemberLaboratory,
});
